import { Black, Gray, Main, Red } from '@constants/color';
import { css } from '@emotion/react';

export const focusedKakaoButton = css({
  backgroundColor: Main.kakao,
  color: Gray.Gray100
});
export const focusedKakaoButtonIcon = css({
  fill: Black.Black10
});

export const failed = css({
  color: Red.Red50
});
